import { navigationItems } from "./navigation-items";
import { NavDropdown } from "./nav-dropdown";
import { ArrowRight } from "lucide-react";
export const DesktopNav = () => {
  const handleDownloadClick = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'nav_download_click', {
        event_category: 'navigation',
        event_label: 'Desktop Navigation Download Button Clicked',
        location: 'navbar'
      });
    }
  };
  return <div className="hidden lg:flex w-full px-8 py-4 items-center justify-between">
      <a href="/" className="flex items-center">
        <img src="/lovable-uploads/Front-Runner-Logo.png" alt="Front Runner: Racehorse Manager Logo" className="h-20 w-auto" />
      </a>

      <div className="flex items-center gap-8">
        <NavDropdown items={navigationItems.learn} trigger="Learn" />
        <NavDropdown items={navigationItems.play} trigger="Play" />
        <a href="https://play.google.com/apps/testing/com.RTz.TWCGame" target="_blank" rel="noopener noreferrer" onClick={handleDownloadClick} className="group flex items-center gap-2 text-white hover:text-racing-accent transition-colors">
          Download
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </div>
    </div>;
};